import { pb } from '@/libs/pocketbase'
import { tryCatch } from '@/utils/try-catch'
import type { VaultDocument, VaultDocumentFilter, VaultDocumentPort, VaultDocumentUpload } from '../domain/document'

const searchParams = (filter: VaultDocumentFilter) => {
	const params = new URLSearchParams()
	if (filter.q) params.set('q', filter.q)
	if (filter.tag) params.set('tag', filter.tag)
	if (filter.includeArchive) params.set('includeArchive', 'true')
	const value = params.toString()
	return value ? `?${value}` : ''
}

const pbVaultDocuments: VaultDocumentPort = {
	list: async (filter: VaultDocumentFilter): Promise<VaultDocument[]> => {
		const result = await tryCatch(
			pb.send<VaultDocument[]>(`/api/vault/documents${searchParams(filter)}`, { method: 'GET', requestKey: null }),
		)
		if (!result.isSuccess) throw new Error(result.error.message)
		return result.data
	},
	upload: async (input: VaultDocumentUpload): Promise<VaultDocument> => {
		const form = new FormData()
		form.append('file', input.file)
		form.append('mimeType', input.file.type)
		form.append('tags', JSON.stringify(input.tags))
		if (input.customerId) form.append('customerId', input.customerId)
		if (input.workItemId) form.append('workItemId', input.workItemId)

		const result = await tryCatch(
			pb.send<VaultDocument>('/api/vault/documents', { method: 'POST', body: form, requestKey: null }),
		)
		if (!result.isSuccess) throw new Error(result.error.message)
		return result.data
	},
	updateTags: async (documentId: string, tags: string[]): Promise<VaultDocument> => {
		const result = await tryCatch(
			pb.send<VaultDocument>(`/api/vault/documents/${documentId}/tags`, {
				method: 'PATCH',
				body: JSON.stringify({ tags }),
				headers: { 'Content-Type': 'application/json' },
				requestKey: null,
			}),
		)
		if (!result.isSuccess) throw new Error(result.error.message)
		return result.data
	},
	archive: async (documentId: string): Promise<void> => {
		const result = await tryCatch(
			pb.send(`/api/vault/documents/${documentId}/archive`, { method: 'POST', requestKey: null }),
		)
		if (!result.isSuccess) throw new Error(result.error.message)
	},
}

export { pbVaultDocuments }
